<template>
    <div class="generic-notification">
        <div v-for="notification in notifications">
            <div class="alert" role="alert" :class="`alert-${notification.cssClass}`">
                {{ verbose ? notification.message : notification.simpleMessage }}
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        notifications: {
            type: Array,
            required: true
        },
        verbose: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data: function () {
        return {}
    },
    created() {
    },
    mounted() {
        console.log('Mounted sub component GenericNotification.');
    },
    computed: {}
};
</script>
